import { RARCS } from '../config'
import { byCode, type CodeOption } from './code-utils'

const RARC_OPTIONS: CodeOption[] = RARCS.map((c) => ({
  label: `${c.code} - ${c.label}`,
  value: c.code,
  description: c.description,
  occurrences: c.occurrences ?? 0,
})).sort(byCode)

export function getRarcOptions(serverValues: string[] | undefined) {
  if (!serverValues || serverValues.length === 0) {
    return RARC_OPTIONS
  }
  // If the value is not found in the RARC_OPTIONS, we still need to show the value in the dropdown
  const additionalOptions = serverValues
    .filter((value) => !RARC_OPTIONS.some((c) => c.value === value))
    .map((value) => ({
      label: value,
      value: value,
      description: '',
      occurrences: 0,
    }))
  return [...RARC_OPTIONS, ...additionalOptions].sort(byCode)
}
